import React from 'react'
import { IncentiveTextBox } from '../baseComponents/IncentiveTextBox'
import { IncentiveHeader } from '../baseComponents/incentiveHeader/IncentiveHeader'

export const IncentiveName = (props: { stateName: string }) => {
    return (
        <div> 
            <IncentiveTextBox stateName={props.stateName} />
        </div>
    )
}
